import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IConfig } from '@onlyoffice/document-editor-angular';
import { AppInitService } from 'src/app/digigov/services/app-init.service';
import { EncryptionService } from 'src/app/digigov/services/encryption.service';

@Component({
  selector: 'app-only-office-window',
  templateUrl: './only-office-window.component.html',
  styleUrls: ['./only-office-window.component.scss'],
})
export class OnlyOfficeWindowComponent implements OnInit {
  allData;
  showOnlyOffice;
  docServerUrl;
  constructor(
    private router: Router,
    private _encryptionService: EncryptionService,
    private appInitService: AppInitService
  ) {
    this.docServerUrl = this.appInitService?.appConfig?.onlyofficeDocumentServerUrl;
    let replacedUrl = this.router.getCurrentNavigation()?.extractedUrl
      ?.queryParams?.path;
    var currentUrl = replacedUrl.split(' ').join('+');
    currentUrl = this._encryptionService.decrypt(
      currentUrl,
      this._encryptionService.param3
    );
    currentUrl = JSON.parse(currentUrl);
    this.allData = currentUrl;
    console.log('test=====', currentUrl);
  }
  //   docx - 130616965
  // xlsx - 130616966
  // pptx - 130616968
  onlyOfficeConfig: IConfig = {
    document: {
      fileType: '',
      key: '',
      title: '',
      url: '',
      permissions: {
        edit: false,
        download: false,
      },
    },
    height: '700px',
    documentType: 'word',
    editorConfig: {
      callbackUrl:
        'http://10.170.68.181:8023/digigov/only-office-service/save-content',
    },
  };
  ngOnInit(): void {
    this.updateOnlyofficeConfig();
  }

  updateOnlyofficeConfig() {
    // Update URL
    if (this.allData?.prePath != undefined || this.allData?.prePath != '') {
      this.onlyOfficeConfig.document.url =
        `http://10.170.68.181:8023/digigov/only-office-service/read-temporary-file?filePath=` +
        this.allData?.prePath;
    } else {
      this.onlyOfficeConfig.document.url =
        `http://10.170.68.181:8023/digigov/only-office-service/files/` +
        this.allData?.mappingId +
        `/contents`;
    }
    // Update key, filetype, doc title etc
    this.onlyOfficeConfig.document.key = 'key_' + this.allData?.mappingId;
    this.onlyOfficeConfig.document.fileType = this.allData?.docMainType;
    if (this.allData?.docMainType == 'xlsx') {
      this.onlyOfficeConfig.documentType = 'cell';
    }
    if (this.allData?.docMainType == 'pptx') {
      this.onlyOfficeConfig.documentType = 'slide';
    }
    this.onlyOfficeConfig.document.title = this.allData?.docFileName;
    // alert('URL is+' + this.allData?.docFileName);
    this.showOnlyOffice = true;
  }

  onlyOfficeOnDocumentReady = (event) => {
    console.log('Document is loaded');
  };

  onLoadComponentError = (errorCode, errorDescription) => {
    switch (errorCode) {
      case -1: // Unknown error loading component
        console.log('onlyoffice', errorDescription);
        break;

      case -2: // Error load DocsAPI from http://documentserver/
        console.log('onlyoffice', errorDescription);
        break;

      case -3: // DocsAPI is not defined
        console.log('onlyoffice', errorDescription);
        break;
    }
  };
}
